import { businessKey } from 'queryKeys';
import { CONCEPTS, cptQuery } from '../../Concepts/data/queryKeyFactory';

const CONCEPT_FAMILIES = 'conceptFamilies';

const MUTATION_ATTACHMENTS = 'attachments';

const cfQuery = businessKey.query(CONCEPT_FAMILIES);

export const details = cfQuery.details();
export const model = cfQuery.exact();

export const grids = cfQuery.grids();
export const grid = cfQuery.grid();

export const attachments = cptQuery.exact(CONCEPTS, MUTATION_ATTACHMENTS);

export const mutations = cfQuery.mutations();
export const remove = mutations.delete();
export const create = mutations.create();
export const update = mutations.update();
